module.exports = __webpack_public_path__ + "img/bb_g1_t_mouth-04.c3c606a9.svg";